import { Link } from "react-router-dom";

/**
 * Hardcoded LiveProcure brand lockup. No longer editable by users.
 *
 * `variant`:
 *   - "sidebar"   — full lockup with mark + name + tagline
 *   - "compact"   — mark + name (mobile header / public navs)
 *   - "mark-only" — just the mark (very small spaces)
 */
export default function BrandLogo({ variant = "sidebar", asLink = false, to = "/dashboard" }) {
  const containerCls = variant === "sidebar" ? "w-9 h-9" : "w-8 h-8";

  const inner = (
    <div className="flex items-center gap-2.5">
      <div className={`${containerCls} rounded-xl overflow-hidden bg-[#0B0F19] flex items-center justify-center shrink-0`}>
        <img
          src="/liveprocure-logo.png"
          alt="LiveProcure"
          className="w-full h-full object-cover"
          data-testid="brand-logo-image"
        />
      </div>
      {variant !== "mark-only" && (
        <div className="min-w-0">
          <div
            className="font-display font-bold text-[#001E44] text-base leading-none tracking-tight truncate"
            data-testid="brand-company-name"
          >
            <span className="text-[#001E44]">live</span>
            <span className="text-[#007BFF]">procure</span>
            <span className="text-[#007BFF]">.com</span>
          </div>
          {variant === "sidebar" && (
            <div
              className="text-[10px] uppercase tracking-[0.2em] text-zinc-400 mt-1 truncate"
              data-testid="brand-tagline"
            >
              Construction Procurement
            </div>
          )}
        </div>
      )}
    </div>
  );

  if (asLink) {
    return (
      <Link to={to} className="inline-flex items-center" data-testid="brand-link">
        {inner}
      </Link>
    );
  }
  return inner;
}
